(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["washed-faq-page"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-faqp]').forEach(function(root){
  var search=root.querySelector('[data-faq-search]');
  var filters=root.querySelectorAll('[data-faq-filters] button');
  var items=root.querySelectorAll('.wsd-faqp__item');
  var heads=root.querySelectorAll('[data-cathead]');
  var none=root.querySelector('[data-faq-none]');
  var activeCat='all';
  function apply(){
    var term=(search&&search.value||'').toLowerCase().trim();
    items.forEach(function(it){
      var okCat=activeCat==='all'||it.getAttribute('data-cat')===activeCat;
      var okTerm=!term||(it.getAttribute('data-text')||'').toLowerCase().indexOf(term)>-1;
      it.hidden=!(okCat&&okTerm);
    });
    heads.forEach(function(h){
      var c=h.getAttribute('data-cathead');var vis=false;
      items.forEach(function(it){ if(it.getAttribute('data-cat')===c && !it.hidden) vis=true; });
      h.hidden=!vis;
    });
    var any=false; items.forEach(function(it){ if(!it.hidden) any=true; });
    if(none) none.hidden=any;
  }
  filters.forEach(function(b){ b.addEventListener('click',function(){
    filters.forEach(function(x){x.classList.remove('is-on');}); b.classList.add('is-on');
    activeCat=b.getAttribute('data-cat'); apply();
  });});
  if(search) search.addEventListener('input',apply);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["washed-stockist-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.stkReady) return;
    root.dataset.stkReady = '1';

    var cards    = Array.prototype.slice.call(root.querySelectorAll('[data-stockist]'));
    var groups   = Array.prototype.slice.call(root.querySelectorAll('[data-country-group]'));
    var cities   = Array.prototype.slice.call(root.querySelectorAll('[data-city-group]'));
    var pills    = Array.prototype.slice.call(root.querySelectorAll('[data-filters] .wsd-pill'));
    var search   = root.querySelector('[data-search]');
    var countEl  = root.querySelector('[data-count]');
    var noneEl   = root.querySelector('[data-none]');
    var mapEl    = root.querySelector('[data-map]');
    var activeCountry = 'all';
    var map = null, markers = [];

    function apply() {
      var term = (search && search.value || '').toLowerCase().trim();
      var shown = 0;

      cards.forEach(function (card, i) {
        var okCountry = activeCountry === 'all' || card.getAttribute('data-country') === activeCountry;
        var okTerm = !term || (card.getAttribute('data-text') || '').toLowerCase().indexOf(term) > -1;
        var visible = okCountry && okTerm;
        card.hidden = !visible;
        if (visible) shown++;
        if (markers[i]) {
          if (visible) { markers[i].addTo(map); } else if (map) { map.removeLayer(markers[i]); }
        }
      });

      cities.forEach(function (c) {
        c.hidden = !c.querySelector('[data-stockist]:not([hidden])');
      });
      groups.forEach(function (g) {
        g.hidden = !g.querySelector('[data-stockist]:not([hidden])');
      });

      if (countEl) countEl.textContent = shown + (shown === 1 ? ' stockist' : ' stockists');
      if (noneEl) noneEl.hidden = shown > 0;

      if (map && shown > 0) {
        var pts = [];
        cards.forEach(function (card, i) { if (!card.hidden && markers[i]) pts.push(markers[i].getLatLng()); });
        if (pts.length === 1) { map.setView(pts[0], parseInt(mapEl.dataset.zoom, 10) || 12); }
        else if (pts.length > 1) { map.fitBounds(L.latLngBounds(pts).pad(0.25)); }
      }
    }

    pills.forEach(function (b) {
      b.addEventListener('click', function () {
        pills.forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        activeCountry = b.getAttribute('data-country');
        apply();
      });
    });
    if (search) search.addEventListener('input', apply);

    function buildMap() {
      if (!mapEl || typeof L === 'undefined') { apply(); return; }
      map = L.map(mapEl, { scrollWheelZoom: false })
             .setView([parseFloat(mapEl.dataset.lat) || 51.5007, parseFloat(mapEl.dataset.lng) || -0.1246],
                      parseInt(mapEl.dataset.zoom, 10) || 12);
      L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
        maxZoom: 19
      }).addTo(map);

      var icon = L.divIcon({ className: '', html: '<div class="wsd-stk__pin"></div>', iconSize: [14, 14], iconAnchor: [7, 7] });

      cards.forEach(function (card, i) {
        var lat = parseFloat(card.getAttribute('data-lat'));
        var lng = parseFloat(card.getAttribute('data-lng'));
        if (isNaN(lat) || isNaN(lng)) { markers[i] = null; return; }
        var name = (card.querySelector('.wsd-stk__name') || {}).textContent || '';
        var addr = (card.querySelector('.wsd-stk__addr') || {}).textContent || '';
        markers[i] = L.marker([lat, lng], { icon: icon })
          .bindPopup('<div class="wsd-stk__pop"><b>' + name + '</b>' + addr + '</div>');
      });
      apply();
    }

    if (typeof L === 'undefined' && mapEl) {
      var s = document.createElement('script');
      s.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      s.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
      s.crossOrigin = '';
      s.onload = buildMap;
      s.onerror = apply;
      document.head.appendChild(s);
    } else {
      buildMap();
    }
  }

  document.querySelectorAll('[data-stk]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-stk]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
